import { useHover as useHover$1 } from '@react-aria/interactions';

/**
 * Hook for managing hover interactions.
 *
 * @param options - Options for the hook.
 */ function useHover(options = {}) {
    const { disabled, readOnly = false } = options;
    const { hoverProps, isHovered } = useHover$1({
        ...options,
        isDisabled: disabled ?? readOnly
    });
    return [
        {
            hovered: isHovered
        },
        {
            hoverProps
        }
    ];
}

export { useHover };
//# sourceMappingURL=use-hover.js.map
